import { render, staticRenderFns } from "./customer-manage.vue?vue&type=template&id=a9b45fee&scoped=true&"
import script from "./customer-manage.vue?vue&type=script&lang=js&"
export * from "./customer-manage.vue?vue&type=script&lang=js&"
import style0 from "./customer-manage.vue?vue&type=style&index=0&id=a9b45fee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b45fee",
  null
  
)

export default component.exports